import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  flex-shrink: 0;\n  height: ', 'px;\n  opacity: ', ';\n  transition: ', ';\n'], ['\n  flex-shrink: 0;\n  height: ', 'px;\n  opacity: ', ';\n  transition: ', ';\n']);

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animationTime } from '../../shared-variables';

var transition = 'height ' + animationTime + ', opacity ' + animationTime;

var RevealInner = styled.div(_templateObject, function (props) {
  return props.isOpen ? props.openHeight : 0;
}, function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.shouldAnimate ? transition : 'none';
});

RevealInner.displayName = 'RevealInner';

RevealInner.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  openHeight: PropTypes.number.isRequired
};

export default RevealInner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/RevealInner.js
// module id = 609
// module chunks = 0